<template>
  <div
    class="d-flex-column justify-start align-start gap-5 filter_item b-radius-9 bosses_bottom_sheet"
  >
    <div class="d-flex-row justify-start gap-5" v-if="showTitle">
      <label for="" class="t-light medium-l font-family-2">{{ title }}</label>
    </div>
    <DropDown
      :drop-items="keyedItems"
      :select-drop-item="handleKey"
      :item-key="itemKey"
      :selected-item="selectedItem"
      :make-unsorted="true"
      :disabled="true"
      @click.stop="openSheet"
      v-if="!isMultiSelect"
    />
    <div
      class="d-flex-row justify-start height-max-content sheet_opener"
      v-if="isMultiSelect"
      @click.stop="openSheet"
    >
      <span
        class="medium-m f-w-400 font-family-2"
        v-html="selectedItemsText"
        :class="selectedItemsText === title ? 't-grey-dark' : 't-white'"
      >
      </span>
      <ChevDown />
    </div>
  </div>
  <ClientOnly>
    <BottomSheet ref="bottomSheet" :snap-points="['50%', '70%']">
      <template #header>
        <div class="d-flex-column justify-start align-start gap-5">
          <h4 class="t-white font-family-1 title-h5 f-w-600">
            {{ title }}
          </h4>
          <label for="" class="t-grey regular-l font-family-2">{{
            description
          }}</label>
        </div>
      </template>

      <!-- CONTENT -->
      <div class="d-flex-column justify-start align-start gap-20">
        <div
          class="d-flex-row justify-start gap-10 bottom_sheet_item"
          v-for="(value, key) in keyedItems"
          :key="key"
          @click="handleKey(filterKey, key)"
        >
          <RadioButton
            variant="secondary"
            :checked="isSelected(key)"
            v-if="!isMultiSelect"
          />
          <CheckboxMin
            variant="secondary"
            :checked="isChecked(key)"
            @change="handleKey(filterKey, key)"
            v-if="isMultiSelect"
          />

          <div class="d-flex-row justify-start gap-5">
            <p class="t-light font-family-2 regular-xl" v-html="value"></p>
          </div>
        </div>
      </div>
      <template #footer>
        <button
          @click="close"
          class="full-width primary filled height-42 t-black font-family-2 bold-xl b-radius-9"
        >
          {{ $t("app.close") }}
        </button>
      </template>
    </BottomSheet>
  </ClientOnly>
</template>

<script setup>
import DropDown from "~/components/custom/DropDown.vue";
import BottomSheet from "@douxcode/vue-spring-bottom-sheet";
import RadioButton from "~/components/custom/RadioButton.vue";
import "@douxcode/vue-spring-bottom-sheet/dist/style.css";
import CheckboxMin from "~/components/custom/CheckboxMin.vue";

import ChevDown from "~/components/icons/ChevDown.vue";
const search = ref("");
const bottomSheet = ref();

const emits = defineEmits(["selectItem"]);
const props = defineProps({
  title: {
    default: "",
  },
  description: {
    default: "",
  },
  items: {
    default: {},
  },
  itemKey: {
    default: "",
  },
  showTitle: {
    default: false,
  },
  classSheet: {
    default: false,
  },
  selectedItem: {
    default: null,
  },
  selectFilter: {
    default: () => {},
  },
  filterKey: {
    default: "",
  },
  isMultiSelect: {
    default: false,
  },
  showTitle: {
    default: true,
  },
  allowNull: {
    default: true,
  },
  showMultiSelectLength: {
    default: false,
  },
});

const isChecked = (item) => {
  const val = parseInt(item);
  return props.selectedItem?.includes(val);
  // return this.modelValue.includes(item) || false;
};
const isSelected = (key) => {
  return key == props.selectedItem;
};
const handleKey = (key, val) => {
  if (props.isMultiSelect) {
    const value = parseInt(val);
    const items = props.selectedItem?.includes(value)
      ? props.selectedItem?.filter((item) => item != value)
      : [...props.selectedItem, value];

    props.selectFilter(props.filterKey, items);
  } else {
    if (props.selectedItem == val && props.selectedItem && props.allowNull) {
      props.selectFilter(props.filterKey, null);
    } else {
      props.selectFilter(props.filterKey, val);
    }
  }

  close();
};

const keyedItems = computed(() => {
  if (Array.isArray(props?.items)) {
    const it = props.items?.reduce((accumulator, value) => {
      let text = value?.price
        ? `<span class='t-white'>${
            value.title
          }</span> <span class='t-blue text-capitalize'>${renderPrice(
            value
          )}</span>`
        : value.title;
      return { ...accumulator, [value[props.itemKey]]: text };
    }, {});
    return it;
  }
  return props.items;
});

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return packOption.type;
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${packOption.price}$`;
  } else {
    return `+${packOption.price}`;
  }
};

const openSheet = () => {
  bottomSheet.value?.open();
};

const close = () => {
  bottomSheet.value?.close();
};

const selectedItemsText = computed(() => {
  if (!props.isMultiSelect) return props.title;

  if (props.isMultiSelect && props.items.length > 0) {
    const items = props.items?.filter((item) =>
      props.selectedItem?.includes(item[props.itemKey])
    );

    if (props.showMultiSelectLength) {
      return `${items.length} Options`;
    }
    if (items) {
      return items?.map((item) => item.title)?.join(", ");
    }
  }
  return props.title;
});
</script>

<style lang="scss">
.sheet_opener {
  background-color: var(--bg-medium);
  border: 1px solid var(--stroke-medium);
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0px 11px 0px 12px;
  width: 100%;
  height: 42px;
  min-height: 42px;
  border-radius: 6px;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
  position: relative;
  outline: none;
  border: none;
  border: 1px solid var(--stroke-medium);
}
.bottom_sheet_picker {
  .dropdown {
    min-height: 48px;
  }
}
.game_picker_container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(auto, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  overflow: auto;
}
.bottom_sheet_item {
  padding: 5px 0;
  padding-bottom: 14px;
  &:not(:last-child) {
    border-bottom: 1px solid var(--stroke-medium);
  }
}
</style>
